module.exports = __webpack_public_path__ + "static/assets/0d80ebe879e62c0b05b9dd2d15a18e81.png";